import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import houseKeeping from "../../../../../assets/images/OUR SERVICES/house-keeping.webp";
import EnquiryModal from '../../../../../common/pages/enquiryModal';
const Housekeeping = () => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    return (
        <React.Fragment>

            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center ">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Housekeeping</h2>

                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10} sm={10}>
                            <Row className="align-items-center gy-4">
                                <Col lg={6} md={12}>
                                    <img
                                        src={houseKeeping}
                                        alt="Housekeeping Items"
                                        className="img-fluid rounded"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </Col>
                                <Col lg={6} md={12}>
                                    <h3 className="fw-bold " style={{ color: "rgb(52, 81, 159)" }}>Housekeeping Items</h3>
                                    <ul className="text-black">
                                        <li><strong>Mops & Brooms</strong> – High-quality cleaning tools for dust and dirt removal.</li>
                                        <li><strong>Garbage Bags</strong> – Durable and eco-friendly waste disposal solutions.</li>
                                        <li><strong>Gloves & Wipes</strong> – Essential safety and cleaning accessories.</li>
                                        <li><strong>Air Fresheners</strong> – Long-lasting fragrances to maintain a fresh environment.</li>
                                        <li><strong>Cleaning Cloths & Dusters</strong> – Microfiber and cotton cloths for various cleaning needs.</li>
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <EnquiryModal isOpen={modal} toggle={toggleModal} />
            </section>
            <section className="section  py-5" style={{ backgroundColor: " rgb(52, 81, 159)" }} id="features">
                <Container>
                    <Row className="justify-content-center">
                        <div className='text-center '>
                            <Button className='px-4 py-2 fw-bold' onClick={toggleModal}
                                style={{ background: "rgb(238, 99, 82)", borderRadius: "20px", color: "white", fontSize: "20px" }}
                            >
                                Enquiry Now
                            </Button>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Housekeeping;